import { object, number, string } from '@gogame/schemas';

import { COLUMN_ID } from 'scenes/CountryGroups/constants';

export const tableSettingsSchema = object({
  limit: number().default(25),
  offset: number().default(0),
  orderBy: string().default(COLUMN_ID),
  orderDir: string().default('desc'),
});
